module.exports = __webpack_public_path__ + "static/media/aboutme-banner.57d970ec.jpg";